export enum ContractDocumentTypeName {
  'Нет',
  'Исходная информация',
  'Результат',
  'Договор',
}
